import './self-pickup-action-menu/self-pickup-action-menu.component';
import './self-pickup-action-menu/self-pickup-action-menu.scss';

import './self-pickup-edit-packages/self-pickup-edit-packages.component';
import './self-pickup-edit-packages/self-pickup-edit-packages.scss';

import './self-pickup-map/self-pickup-map.component';
import './self-pickup-map/self-pickup-map.scss';

import './self-pickup-panel/self-pickup-panel.component';
import './self-pickup-panel/self-pickup-panel.scss';

import './self-pickup-status-button/self-pickup-status-button.component';
import './self-pickup-status-button/self-pickup-status-button.scss';

import './self-pickup-status-select/self-pickup-status-select.component';
import './self-pickup-status-select/self-pickup-status-select.scss';

import './self-pickup-status-tag/self-pickup-status-tag.component';
import './self-pickup-status-tag/self-pickup-status-tag.scss';

import './self-pickup-timeline-list/self-pickup-timeline-list.component';
import './self-pickup-timeline-list/self-pickup-timeline-list.scss';

import './self-pickup-type-icon/self-pickup-type-icon.component';

import './self-pickups-table/self-pickups-table.component';
import './self-pickups-table/self-pickups-table.scss';

import './self-pickups-table-row/self-pickups-table-row.component';
import './self-pickups-table-row/self-pickups-table-row.scss';

import './self-pickups-view/self-pickups-view.component';
import './self-pickups-view/self-pickups-view.scss';

import './self-pickups-view-no-depots/self-pickups-view-no-depots.component';

import './israel-post-view/israel-post-view.component';
import './israel-post-view/israel-post-view.scss';
